import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IProposeATimeStore {
  openProgressSheet: (therapist) => void;
  requestSubmitted$: Observable<boolean>;
  proposeATimeClicked$: () => boolean;
}

export const PROPOSE_A_TIME_STORE = new InjectionToken<IProposeATimeStore>('IProposeATimeStore');
